import Call from '@/api/call'
import loading from '../helpers/loading'

export default {
  namespaced: true,
  state: {
    ...loading.state
  },
  mutations: {
    ...loading.mutations
  },
  getters: {
    ...loading.getters
  },
  actions: {
    createAppointment: ({ commit }, { userId, adminId, callAt }) => {
      commit('changeLoading', { isLoading: true })
      return Call.createAppointment({ userId, adminId, callAt })
        .then(({ data }) => {
          commit('skiliko/purchases/replaceItem', { item: data }, { root: true })
          commit('changeLoading', { isLoading: false })
          return data
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    },
    hangup: ({ commit }, { id }) => {
      commit('changeLoading', { isLoading: true })
      return Call.hangup({ id })
        .then(({ data }) => {
          commit('skiliko/purchases/replaceItem', { item: data }, { root: true })
          commit('changeLoading', { isLoading: false })
          return data
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    },
    fetchAudio: ({ commit }, { id }) => {
      commit('changeLoading', { isLoading: true })
      return Call.record({ id })
        .then(({ data }) => {
          commit('changeLoading', { isLoading: false })
          return data
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/call/index.js